import React, { Component } from 'react';
import { DatasetPresence, DatasetPresences, PricesPresence, PricesPresences } from '~/Api/Product';
import ProductDatasourceSelect from '~/ProductDatasourceSelect';
import Button, { Link } from '~/UI/Button';
import linkButtonStyles from '~/UI/Button/link-small.less';
import primaryAltSmallButtonStyles from '~/UI/Button/primary-alt-small.less';
import secondarySmallButtonStyles from '~/UI/Button/secondary-small.less';
import Heading from '~/UI/Heading/Heading';
import ModalBody from '~/UI/Modal/Body/ModalBody';
import modalCompactStyles from '~/UI/Modal/compact.less';
import ModalContent from '~/UI/Modal/Content/ModalContent';
import ModalFooter from '~/UI/Modal/Footer/ModalFooter';
import ModalHeader from '~/UI/Modal/Header/ModalHeader';
import Modal from '~/UI/Modal/Modal';
import Radio from '~/UI/Radio';

import styles from './styles.less';

interface Props {
	dataSourceTypes: Set<string> | null;
	pricesPresence: PricesPresence | null;
	datasetPresence: DatasetPresence;
	selectedGrouppingType: string | null;
	onClose(): void;
	onConfirm(
		dataSourceTypes: Set<string> | null,
		pricesPresence: PricesPresence | null,
		datasetPresence: DatasetPresence,
		selectedGrouppingType: string | null,
		groupName: string | null
	): void;
}

interface State {
	dataSourceTypes: Set<string> | null;
	pricesPresence: PricesPresence | null;
	datasetPresence: DatasetPresence;
	selectedGrouppingType: string | null;
	groupName: string | null;
}

export default class SearchSettingsModal extends Component<Props, State> {
	state: State = {
		dataSourceTypes: this.props.dataSourceTypes,
		datasetPresence: this.props.datasetPresence,
		groupName: null,
		selectedGrouppingType: this.props.selectedGrouppingType,
		pricesPresence: this.props.pricesPresence,
	};

	handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
		const {
			props: { onConfirm },
			state: { dataSourceTypes, pricesPresence, datasetPresence, selectedGrouppingType, groupName },
		} = this;

		event.preventDefault();
		onConfirm(dataSourceTypes, pricesPresence, datasetPresence, selectedGrouppingType, groupName);
	};

	private handleSettingsReset = () => {
		this.setState({
			datasetPresence: DatasetPresences.present,
			dataSourceTypes: null,
			groupName: null,
			pricesPresence: null,
			selectedGrouppingType: null,
		});
	};

	render() {
		const {
			props: { onClose },
			state: { dataSourceTypes, pricesPresence, datasetPresence },
		} = this;

		return (
			<Modal styles={modalCompactStyles} onClose={onClose}>
				<form style={{ height: '100%' }} onSubmit={this.handleFormSubmit}>
					<ModalContent>
						<ModalHeader>
							<Heading level={2}>Search Settings</Heading>
						</ModalHeader>
						<ModalBody>
							<div className={styles.column}>
								<Heading level={2}>Choose datasources:</Heading>
								<p className={styles.header}>
									You can choose the data sources from which you want to include products in your search.
									<Link styles={linkButtonStyles} to='/datasources'>
										More info.
									</Link>
								</p>
								<ProductDatasourceSelect
									currentTypes={dataSourceTypes}
									selectedGrouppingType={this.state.selectedGrouppingType}
									onChange={(types, selectedGrouppingType, groupName) =>
										this.setState({ dataSourceTypes: types, selectedGrouppingType, groupName })
									}
								/>
							</div>

							<div className={styles.column}>
								<Heading level={2}>Products with price:</Heading>
								<p className={styles.header}>Setup search to include only products with price: </p>

								<Radio
									checked={!pricesPresence}
									id='price-filter-all'
									name='price-filter'
									onChange={() => this.setState({ pricesPresence: null })}
								>
									<strong>all</strong> products (default)
								</Radio>
								<Radio
									checked={pricesPresence === PricesPresences.atLeastOne}
									id='price-filter-with-price'
									name='price-filter'
									onChange={() =>
										this.setState({
											pricesPresence: PricesPresences.atLeastOne,
										})
									}
								>
									products with <strong>at least one price</strong>
								</Radio>

								<Heading level={2}>Presence in dataset:</Heading>
								<p className={styles.header}>
									As datasets change in time, products might have been removed from newer versions. You can choose to
									search also in removed products:{' '}
								</p>

								<div>
									<Radio
										checked={datasetPresence === DatasetPresences.all}
										id='dataset-presence-all'
										name='dataset-presence'
										onChange={() => this.setState({ datasetPresence: DatasetPresences.all })}
									>
										<strong>all</strong> products
									</Radio>
								</div>
								<div>
									<Radio
										checked={datasetPresence === DatasetPresences.present}
										id='dataset-presence-present'
										name='dataset-presence'
										onChange={() =>
											this.setState({
												datasetPresence: DatasetPresences.present,
											})
										}
									>
										only <strong>present</strong> products (default)
									</Radio>
								</div>
								<div>
									<Radio
										checked={datasetPresence === DatasetPresences.notPresent}
										id='dataset-presence-only-removed'
										name='dataset-presence'
										onChange={() =>
											this.setState({
												datasetPresence: DatasetPresences.notPresent,
											})
										}
									>
										only <strong>removed</strong> products
									</Radio>
								</div>
							</div>
						</ModalBody>
						<ModalFooter>
							<div className={styles.resetButtons}>
								<Link styles={secondarySmallButtonStyles} onClick={this.handleSettingsReset}>
									Reset
								</Link>
							</div>
							<div className={styles.footerButton}>
								<Link styles={secondarySmallButtonStyles} onClick={onClose}>
									Close
								</Link>
							</div>
							<div className={styles.footerButton}>
								<Button styles={primaryAltSmallButtonStyles}>Save Settings</Button>
							</div>
						</ModalFooter>
					</ModalContent>
				</form>
			</Modal>
		);
	}
}
